import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { fetchWithAuth } from '../../../utils/apiAuth';
import config from '../../../config';

const apiBaseUrl = config.getApiUrl();

/**
 * Redirects to the admin login when there is no token, or when the stored
 * token is rejected by the API. Also exposes an explicit logout action.
 */
export const useAdminAuthGuard = () => {
  const navigate = useNavigate();
  const { token, logout } = useAuth();

  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        navigate('/yploginadmin');
        return;
      }

      try {
        await fetchWithAuth(`${apiBaseUrl}/api/auth/me`);
      } catch (error) {
        console.error('Token validation failed:', error);
        if (error.message.includes('unauthorized') || error.message.includes('invalid') || error.message.includes('expired')) {
          logout();
          navigate('/yploginadmin');
        }
      }
    };

    validateToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/yploginadmin');
  };

  return { handleLogout };
};
